<template>
  <v-dialog
    v-model="dialog"
    max-width="420px"
  >
    <v-card
      class="pa-4"
      elevation="8"
      rounded="xl"
      color="#fff"
    >
      <div class="d-flex justify-space-between align-center mb-3">
        <h3 class="text-h6 font-weight-bold">
          Check Out
        </h3>
        <v-btn
          icon
          light
          @click="closeDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-form ref="checkoutForm">
        <v-radio-group
          v-model="selectedDateOption"
          row
          dense
          hide-details
          class="mb-3"
          @change="handleDateChange"
        >
          <v-radio
            label="Today"
            value="today"
            color="#37474F"
            light
          />
          <v-radio
            label="Yesterday"
            value="yesterday"
            :disabled="isCheckinToday"
            color="#37474F"
            light
          />
        </v-radio-group>

        <v-text-field
          v-model="time"
          label="Select Time"
          placeholder="hh:mm AM/PM"
          outlined
          dense
          light
          class="mb-4"
          :rules="[validateTime, validateNotFuture, validateAfterCheckin]"
          @input="handleTimeInput"
          @blur="formatTime"
        />
      </v-form>
      <div class="d-flex justify-end">
        <v-btn
          text
          color="#37474F"
          small
          class="mr-2"
          @click="closeDialog"
        >
          Cancel
        </v-btn>

        <v-btn
          color="#C62828"
          dark
          small
          @click="handleCheckout"
        >
          Check Out
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import Constants from 'src/constants';

export default {
  name: 'CheckinPopUp',

  props: {
    show: Boolean,
    checkinId: {
      type: String,
      default: '',
    },
    checkinTime: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      dialog: true,
      date: moment().format('YYYY-MM-DD'),
      time: moment().format('hh:mm A'),
      today: moment().format('YYYY-MM-DD'),
      selectedDateOption: 'today',
      dateMenu: false,
    };
  },
  computed: {
    isCheckinToday () {
      if (!this.checkinTime) return false;
      console.log({
        raw: this.checkinTime,
        local: moment.utc(this.checkinTime).local().format(),
        today: moment().format(),
        result: moment.utc(this.checkinTime).local().isSame(moment(), 'day'),
      });
      return moment.utc(this.checkinTime).local().isSame(moment(), 'day');
    },
  },
  methods: {
    closeDialog () {
      this.dialog = false;
      this.$emit('close');
    },
    validateAfterCheckin (value) {
      if (!value || !this.checkinTime) return true;

      const checkoutLocal = moment(
        `${this.date} ${value}`,
        'YYYY-MM-DD hh:mm A',
      );

      const checkinLocal = moment.utc(this.checkinTime).local();

      return (
        checkoutLocal.isAfter(checkinLocal) ||
        'Checkout time must be greater than checkin time'
      );
    },
    handleCheckout () {
      const isValid = this.$refs.checkoutForm.validate();

      if (!isValid) return;

      const localDateTime = moment(
        `${this.date} ${this.time}`,
        'YYYY-MM-DD hh:mm A',
      );

      this.$store
        .dispatch('swiftuser/checkOutUser', {
          checkInId: this.checkinId,
          checkOutTime: {
            checkout_time: localDateTime.utc().format(),
            type: 'admin-checkout',
          },
        })
        .then(() => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Check-out completed successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });

          this.closeDialog();
        })
        .catch((error) => {
          this.$store.dispatch('alert/onAlert', {
            message: `${error.response.data.message}`,
            type: Constants.ALERT_TYPE_ERROR,
          });
        });
    },

    formatTime () {
      if (!this.time) return;

      const m = moment(
        this.time,
        ['HH:mm', 'H:mm', 'hh:mm A', 'h:mmA', 'hh:mmA'],
        true,
      );

      if (m.isValid()) {
        this.time = m.format('hh:mm A');
      }
    },
handleTimeInput (value) {
  if (!value) return;

  const digits = value.replace(/\D/g, '').slice(0, 4);

  let formatted = digits;

  if (digits.length >= 3) {
    formatted = digits.slice(0, 2) + ':' + digits.slice(2);
  }

  this.time = formatted;
},
    validateTime (value) {
      if (!value) return 'Time is required';

      const isValid = moment(value, 'hh:mm A', true).isValid();
      return isValid || 'Invalid time format (e.g., 02:30 PM)';
    },
    validateNotFuture (value) {
      if (!value) return true;

      const selected = moment(`${this.date} ${value}`, 'YYYY-MM-DD hh:mm A');

      if (selected.isAfter(moment())) {
        return 'Future time not allowed';
      }

      return true;
    },
    handleDateChange () {
      this.date =
        this.selectedDateOption === 'today'
          ? moment().format('YYYY-MM-DD')
          : moment().subtract(1, 'day').format('YYYY-MM-DD');
    },
  },
};
</script>
<style scoped>
::v-deep .v-input--selection-controls__input .v-icon {
  color: rgb(8, 8, 8) !important;
}
.v-list-item__title {
  color: #0000 !important;
}
.theme--dark >>> .v-list-item {
  color: #37474f !important;
}
</style>
